import BarChart from "../Charts/BarChart";

const DashboardTopItemsChart = ({ dashBoardSummary, loading }) => {
    if (!dashBoardSummary?.orderItemsCount) return null;

    return (
        <>
            <h3 className="text-center mt-5">
                Artículos más pedidos del mes
            </h3>
            <div className="row mb-5 justify-content-center">
                {
                    Object.keys(dashBoardSummary?.orderItemsCount).length > 0 && !loading ?
                        Object.keys(dashBoardSummary?.orderItemsCount).map((key, i) => {
                            return (
                                <div className={`col-md-${12 / Object.keys(dashBoardSummary?.orderItemsCount).length}`} key={i}>
                                    <h5 className="text-center my-4">
                                        Pedido {key}
                                    </h5>
                                    <BarChart
                                        categories={dashBoardSummary?.orderItemsCount?.[key]?.map(value => value?.name.toLocaleUpperCase())}
                                        defaultSeries={[
                                            {
                                                data: dashBoardSummary?.orderItemsCount?.[key]?.map(value => Number(value?.count))
                                            }
                                        ]}
                                    />
                                </div>
                            )
                        })
                        :
                        <h3 className="text-center text-danger">
                            No hay datos para mostrar.
                        </h3>
                }
            </div>
        </>
    );
};

export default DashboardTopItemsChart;
